import React, { useState, createContext, useContext } from 'react';
interface ClientContextType {
  clientName: string;
  setClientName: (name: string) => void;
  companyName: string;
  setCompanyName: (name: string) => void;
}
// Updated default values in createContext to reflect new initial state
const ClientContext = createContext<ClientContextType>({
  clientName: 'Amrit Thandi',
  setClientName: () => {},
  companyName: 'Accutemp Limited',
  setCompanyName: () => {}
});
export function ClientProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [clientName, setClientName] = useState('Amrit Thandi');
  const [companyName, setCompanyName] = useState('Accutemp Limited');
  return <ClientContext.Provider value={{
    clientName,
    setClientName,
    companyName,
    setCompanyName
  }} data-id="element-36">
      {children}
    </ClientContext.Provider>;
}
export function useClient() {
  return useContext(ClientContext);
}